import { render, staticRenderFns } from "./GameList2.vue?vue&type=template&id=e7e770d4&scoped=true&"
import script from "./GameList2.vue?vue&type=script&lang=js&"
export * from "./GameList2.vue?vue&type=script&lang=js&"
import style0 from "./GameList2.vue?vue&type=style&index=0&id=e7e770d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e770d4",
  null
  
)

export default component.exports